import React from 'react';
import { formatArchivoSubidoMeta, type IProfaseArchivo } from './profase-archivo-api';
import './archivo-viewer-title.css';

interface ArchivoViewerTitleProps {
  archivo: IProfaseArchivo | null;
  fallback: string;
  className?: string;
}

export default function ArchivoViewerTitle({
  archivo,
  fallback,
  className,
}: ArchivoViewerTitleProps) {
  const meta = formatArchivoSubidoMeta(archivo?.data);

  return (
    <span className={className}>
      {archivo?.nombre ?? fallback}
      {meta ? <span className="archivo-viewer-title__meta">{meta}</span> : null}
    </span>
  );
}
